import { render } from "./MainBanner.vue?vue&type=template&id=34e95e76"
import script from "./MainBanner.vue?vue&type=script&lang=js"
export * from "./MainBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__